import { cn } from '@/lib/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'circular' | 'text';
  animation?: 'pulse' | 'shimmer' | 'none';
}

function Skeleton({
  className,
  variant = 'default',
  animation = 'pulse',
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(
        'bg-[var(--primary)]/8 dark:bg-[var(--primary)]/12',
        variant === 'circular' && 'rounded-pill',
        variant === 'text' && 'rounded-card h-4',
        variant === 'default' && 'rounded-card',
        animation === 'pulse' && 'animate-pulse',
        animation === 'shimmer' && [
          'relative overflow-hidden',
          'before:absolute before:inset-0',
          'before:-translate-x-full before:animate-[shimmer_2s_infinite]',
          'before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent',
        ],
        className
      )}
      {...props}
    />
  );
}

// Готовые пресеты
function SkeletonCard() {
  return (
    <div className="space-y-3">
      <Skeleton className="aspect-square w-full rounded-card" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
}

function SkeletonAvatar({ size = 'default' }: { size?: 'sm' | 'default' | 'lg' }) {
  const sizes = {
    sm: 'h-8 w-8',
    default: 'h-10 w-10',
    lg: 'h-12 w-12',
  };
  
  return <Skeleton variant="circular" className={sizes[size]} />;
}

function SkeletonText({ lines = 3 }: { lines?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          variant="text"
          style={{ width: i === lines - 1 ? '60%' : '100%' }}
        />
      ))}
    </div>
  );
}

export { Skeleton, SkeletonCard, SkeletonAvatar, SkeletonText };

